import { z } from 'zod';
export const EmbedLoginRequestSchema = z.object({
    accessToken: z.string().min(1),
});
export const SessionUserSchema = z.object({
    box_id: z.number(),
    arbox_users_id: z.number(),
    arbox_users_boxes_id: z.number(),
});
export const EmbedLoginResponseSchema = z.object({
    token: z.string(),
    user: SessionUserSchema,
});
//# sourceMappingURL=auth.js.map